"use client";

import { Tabs } from "@/components/ui/tabs";
import { get } from "@/utils/utils";
import { useMemo, useState } from "react";
import ActivityTab from "./tabs/activity";
import CommentsTab from "./tabs/comments";
import HoldersTab from "./tabs/holders";

type TabType = "comments" | "holders" | "activity";

interface GuessOption {
    guessNo: string;
    title: string;
}

interface EngagementSectionProps {
    eventNo: string;
    commentId?: string;
    eventData?: { eventImageUrl?: string; eventTitle: string; position?: "Yes" | "No" | "No Position" };
    guessList?: GuessOption[];
    matchups?: any[];
}

const TAB_CONFIG: { id: TabType; label: string }[] = [ { id: "holders", label: "Holders" }, {
    id: "activity",
    label: "Activity",
}, { id: "comments", label: "Comments" } ];
const DefaultTab: TabType = TAB_CONFIG[0].id;

export default function EngagementSection(
    { eventNo, commentId, eventData, guessList = [], matchups }: EngagementSectionProps,
) {
    const [ activeTab, setActiveTab ] = useState<TabType>( DefaultTab );

    const normalizedGuessList = useMemo( () => {
        return guessList.map( ( guess ) => ( {
            guessNo: guess.guessNo,
            title: guess.title,
            mainFlag: get( guess, "mainFlag" ),
            yesDesc: get( guess, "yesDesc" ),
            noDesc: get( guess, "noDesc" ),
        } ) );
    }, [ guessList ] );

    return (
        <div className="mt-3 mb-3 flex flex-col gap-3 rounded-xl border border-stroke bg-surface-card p-3">
            <Tabs
                tabs={TAB_CONFIG.map( ( tab ) => ( { label: tab.label, value: tab.id } ) )}
                activeTab={activeTab}
                onTabChange={( value ) => setActiveTab( value as TabType )}
                className="mb-0 [&_[data-slot=indicator]]:h-0.5"
                itemClassName="h-8 min-h-[32px] px-0 py-1.5 text-[16px] font-semibold leading-normal"
                activeItemClassName="font-bold"
                inactiveItemClassName="font-semibold text-t3"
            />

            <div className="flex min-h-0 flex-col gap-3">
                {activeTab === "comments" && (
                    <CommentsTab eventNo={eventNo} commentId={commentId} eventData={eventData} matchups={matchups} />
                )}

                {activeTab === "holders" && <HoldersTab guessList={normalizedGuessList} matchups={matchups} />}

                {activeTab === "activity" && <ActivityTab eventNo={eventNo} guessList={normalizedGuessList} />}
            </div>
        </div>
    );
}
